import { useScenariosStore } from '@/stores/scenarios';
import { useWorkpackagesStore } from '@/stores/workpackages';
import to from 'await-to-js';
import axios from 'axios';
import _ from 'lodash';
import { defineStore } from 'pinia';
// Stores

export const useDependencyTreeStore = defineStore('dependency-tree', () => {
  const workpackagesStore = useWorkpackagesStore();
  const scenariosStore = useScenariosStore();

  async function triggerDependencyTree(args) {
    const workpackageId = workpackagesStore.selectedWorkpackage?._id;
    const workpackageType = workpackagesStore.selectedWorkpackage?.type;
    const scenarioId = scenariosStore.selectedScenario?._id;

    function checkTypes(params) {
      // ensure that all required params have correct types
      const typeChecks = [
        _.isString(params.change),
        _.isObject(params.updates),
        _.isBoolean(params.commit),
      ];

      if (_.some(typeChecks, check => check === false))
        throw new Error('Invalid dependency parameters');
    }

    checkTypes(args.params);

    const params = {
      // workpackageId and scenarioId can be overwritten
      workpackageId,
      workpackageType,
      scenarioId,
      ...args.params,
    };

    const [err, response] = await to(axios.post('/api/dependency-tree', { params }));
    if (err) throw new Error(err.message);

    return response.data;
  }

  return { triggerDependencyTree };
});
